import { render, staticRenderFns } from "./gj-double-select-input.vue?vue&type=template&id=15ce0b29&scoped=true&"
import script from "./gj-double-select-input.vue?vue&type=script&lang=js&"
export * from "./gj-double-select-input.vue?vue&type=script&lang=js&"
import style0 from "./gj-double-select-input.vue?vue&type=style&index=0&id=15ce0b29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ce0b29",
  null
  
)

export default component.exports